import Tools from "./JNSTools";

class GlobalData {
  constructor(creds) {
    this.creds = creds;
    this.users = [];
    this.tableQueries = [
      {
        table: "BookingType",
        query:
          '<Read type="BookingType" method="equal to" limit="1000" order="name"><BookingType><active>1</active></BookingType><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Category",
        query:
          '<Read type="Category" method="equal to" limit="1000" order="name"><Category><active>1</active></Category><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Customer",
        query:
          '<Read type="Customer" method="equal to" order="name"><Customer><active>1</active></Customer><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "IssueCategory",
        query:
          '<Read type="IssueCategory" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "IssueSeverity",
        query:
          '<Read type="IssueSeverity" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "IssueSource",
        query:
          '<Read type="IssueSource" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "IssueStage",
        query:
          '<Read type="IssueStage" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "IssueStatus",
        query:
          '<Read type="IssueStatus" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Jobcode",
        query:
          '<Read type="Jobcode" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Projectgroup",
        query:
          '<Read type="Projectgroup" method="all" limit="1000"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Ratecard",
        query:
          '<Read type="Ratecard" method="equal to" limit="1000" order="name"><Ratecard><active>1</active></Ratecard><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Slipstage",
        query:
          '<Read type="Slipstage" method="equal to" limit="1000" order="name"><Slipstage><active>1</active></Slipstage><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "User",
        query:
          '<Read type="User" method="all" limit="1000" order="name" enable_custom="1" generic="1"><_Return><id/><name/><active/><generic/><nickname/><oada_userid__c/><oada_user_client__c/><oada_role__c/><oada_password__c/><oada_last_dashboard_view__c/><oada_modules__c/></_Return></Read>',
      },
      {
        table: "Resourceprofile_type",
        query:
          '<Read type="Resourceprofile_type" method="equal to" limit="1000" order="name"><Resourceprofile_type><active>1</active></Resourceprofile_type><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Attribute",
        query:
          '<Read type="Attribute" method="equal to" limit="1000" order="name"><Attribute><active>1</active></Attribute><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Attributeset",
        query:
          '<Read type="Attributeset" method="all" limit="1000" order="name"><_Return><id/><name/></_Return></Read>',
      },
      {
        table: "Workspacelink",
        query: '<Read type="Workspacelink" method="all" limit="1000"></Read>',
      },
    ];
  }

  async populateTable(table, refresh) {
    const localData = localStorage.getItem(this.creds.company + "|" + table);

    if (localData && !refresh) {
      return new Promise((resolve) => {
        resolve(JSON.parse(localData));
      });
    } else {
      const matchFunction = (obj) => obj.table == table;
      const tableQueryIndex = this.tableQueries.findIndex(matchFunction);
      const requestString =
        Tools.getXmlBodyAuthString(this.creds) +
        this.tableQueries[tableQueryIndex].query +
        "</request>";

      const idField = "id";
      let valueField = "name";
      if (table == "Workspacelink") {
        valueField = "description";
      }
      const genericField = "generic";
      const genericNicknameField = "oada_userid__c";
      const regularNicknameField = "nickname";
      const genericClientField = "oada_user_client__c";
      const roleField = "oada_role__c";
      const activeField = "active";
      const lastDashboardViewField = "oada_last_dashboard_view__c";
      const genericPasswordField = "oada_password__c";
      const modulesField = "oada_modules__c";

      const urlString = Tools.getInstanceUrl(this.creds);

      const promiseObj = Tools.fetchPost(requestString, urlString).then(
        (responseObject) => {
          if (
            responseObject.authStatus == "0" //&&
            //responseObject.postStatus == "0"
          ) {
            const xml = responseObject.xml;
            const responseKeyNodes = xml.querySelectorAll(idField);
            const responseValueNodes = xml.querySelectorAll(valueField);
            const responseActiveNodes = xml.querySelectorAll(activeField);
            const responseGenericNodes = xml.querySelectorAll(genericField);
            const responseGenericNicknameNodes =
              xml.querySelectorAll(genericNicknameField);
            const responseRegularNicknameNodes =
              xml.querySelectorAll(regularNicknameField);
            const responseGenericClientNodes =
              xml.querySelectorAll(genericClientField);
            const responseRoleNodes = xml.querySelectorAll(roleField);
            const responseLastDashboardViewNodes = xml.querySelectorAll(
              lastDashboardViewField,
            );
            const responseGenericPasswordNodes =
              xml.querySelectorAll(genericPasswordField);
            const responseModulesNodes = xml.querySelectorAll(modulesField);

            const returnArray = [];

            for (let i = 0; i < responseKeyNodes.length; i++) {
              returnArray.push({
                id: responseKeyNodes[i].textContent,
                name: responseValueNodes[i].textContent,
                active:
                  responseActiveNodes.length > 0
                    ? responseActiveNodes[i].textContent
                    : "",
                role:
                  responseRoleNodes.length > 0
                    ? responseRoleNodes[i].textContent
                    : "",
                generic:
                  responseGenericNodes.length > 0
                    ? responseGenericNodes[i].textContent
                    : "",
                nickname:
                  table == "User"
                    ? responseGenericNicknameNodes.length > 0
                      ? responseGenericNicknameNodes[i].textContent != ""
                        ? responseGenericNicknameNodes[i].textContent
                        : responseRegularNicknameNodes[i].textContent
                      : responseRegularNicknameNodes[i].textContent
                    : "",
                client:
                  responseGenericClientNodes.length > 0
                    ? responseGenericClientNodes[i].textContent
                    : 0,
                lastDashboardView:
                  responseLastDashboardViewNodes.length > 0 &&
                  responseLastDashboardViewNodes[i].textContent.substring(
                    0,
                    10,
                  ) != "0000-00-00"
                    ? responseLastDashboardViewNodes[i].textContent.substring(
                        0,
                        10,
                      )
                    : "",
                genericPassword:
                  responseGenericPasswordNodes.length > 0
                    ? responseGenericPasswordNodes[i].textContent
                    : "",
                modules:
                  responseModulesNodes.length > 0
                    ? responseModulesNodes[i].textContent
                    : "",
              });
            }

            localStorage.removeItem(this.creds.company + "|" + table);
            localStorage.setItem(
              this.creds.company + "|" + table,
              JSON.stringify(returnArray),
            );

            return returnArray;
          }
        },
      );
      return promiseObj;
    }
  }
}

export default GlobalData;
